export const langEn = {
  'common.expected_finish': 'Expected Finish',
  'common.minutes': 'min',
  'common.now': 'Now',
  'common.next': 'Next',
  'common.public_message': 'Public message',
  'common.scheduled_start': 'Scheduled start',
  'common.scheduled_end': 'Scheduled end',
  'common.projected_start': 'Projected start',
  'common.projected_end': 'Projected end',
  'common.stage_timer': 'Stage Timer',
  'common.started_at': 'Started At',
  'common.time_now': 'Time now',
  'countdown.ended': 'Event ended at',
  'countdown.running': 'Event running',
  'countdown.select_event': 'Select an event to follow',
  'countdown.to_start': 'Time to start',
  'countdown.waiting': 'Waiting for event start',
  'countdown.overtime': 'in overtime',
  'timeline.live': 'live',
  'timeline.done': 'done',
  'timeline.due': 'due',
  'timeline.followedby': 'Followed by',
};

export type TranslationObject = Record<keyof typeof langEn, string>;
